export function computePageNumberXY({
  pageWidth,
  pageHeight,
  textWidth,
  textHeight,
  position,
  marginH,
  marginV,
}) {
  const isTop = position.startsWith('top');
  const isCenter = position.endsWith('center');
  const isRight = position.endsWith('right');
  const x = isCenter ? (pageWidth - textWidth) / 2 : isRight ? pageWidth - marginH - textWidth : marginH;
  const y = isTop ? pageHeight - marginV - textHeight : marginV;
  return { x, y };
}
